<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="quantumForm">
      <div class="">
        <h3 class="form_name">Quantum</h3>


        <div class="input">
          <label for="">Quantum of Impact Name</label>
          <input type="text" class="default_input reference-form" formControlName="QuantumName" />
        </div>

        <div class="input">
          <label for="">Distributor Factor Value</label>
          <input type="number" class="default_input reference-form" formControlName="DistributorFactorValue" />
        </div>

        <div class="input">
          <label for="">Distributor Factor Name</label>
          <input type="text" class="default_input reference-form" formControlName="DistributorFactorName" />
        </div>


        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null"
            (click)="addNew(quantumForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(quantumForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

        </div>

      </div>
    </form>
    <div class="display_table">
      <div class="search_container">
        <input type="text" class="default_input search" placeholder="Search for Quantum" [formControl]="control"
          [appAutocomplete]="autocomplete" />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container *ngIf="(quantums | filterReference: control.value) as result">
              <app-option (click)="selectQuantum(option.id)" *ngFor="let option of result" [value]="option.QuantumName">
                {{ option.QuantumName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length">No result...</app-option>
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head">
        <span class="item">S/N</span>
        <span class="item">Quantum Name</span>
        <span class="item">Distributor Factor Name</span>
        <span class="item">Distributor Factor Value</span>
        <span class="item">Action</span>

      </div>

      <div class="scroll">

      </div>
      <div class="body_content">
        <div class="the_body" *ngFor="let quantum of quantumFormArray.get('Quantums')['controls']; index as i"
          (click)="onEdit(i, quantum.value)" style="cursor: pointer;" matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over">
          <span class="content">{{i + 1}}</span>
          <span class="content">{{quantum.value.QuantumName}}</span>
          <span class="content">{{quantum.value.DistributorFactorName}}</span>
          <span class="content">{{quantum.value.DistributorFactorValue}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button class="delete_icon trash" (click)="deleteQuantum(i, quantum.value)">
              <em class="ti-trash"> </em> </button>
          </span>

        </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(quantumFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
